"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

function SelfNavigation(props) {
  var configuration = (props || {}).configuration;

  var _a = (0, _react.useState)(false),
      expendNode = _a[0],
      setExpendNode = _a[1];

  var _b = (0, _react.useState)(configuration ? configuration[0] : {}),
      currentTxt = _b[0],
      setCurrentTxt = _b[1];

  var containerRef = (0, _react.useRef)(null);
  var li_a = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      var getFirstNodePos = document.querySelector("" + currentTxt.anchorId); // @ts-ignore

      var scroll_val = getFirstNodePos && getFirstNodePos.offsetTop; // console.log(getFirstNodePos);

      var wi_w = document.documentElement.offsetWidth || document.body.offsetWidth;

      if (wi_w <= 768) {
        window.onscroll = function () {
          // @ts-ignore
          if (!(containerRef.current && containerRef.current.style) || !containerRef.current) return;
          var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

          if (scrollTop > scroll_val + 100 && containerRef.current) {
            // @ts-ignore
            containerRef.current.style.display = 'block';
          } else {
            // @ts-ignore
            containerRef.current.style.display = 'none';
          } // console.log('滚动距离' + scrollTop);

        };
      }
    }, 1000);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: containerRef,
    className: 'self-navigation-container'
  }, /*#__PURE__*/_react["default"].createElement("a", {
    onClick: function onClick() {
      // @ts-ignore
      if (!li_a.current || !li_a.current.style) return;
      var _height = 0;

      if (!expendNode) {
        setExpendNode(true);
        _height = configuration.length ? configuration.length * 56 + 'px' : 0;
      } else {
        setExpendNode(false);
        _height = 0;
      } // @ts-ignore


      li_a.current.style.height = _height;
    },
    className: 'self-navigation-container__nav'
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: 'self-navigation-container__nav__h3'
  }, currentTxt ? currentTxt.label : ''), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('self-navigation-container__nav__span', {
      'self-navigation-container__nav__span--rotate': expendNode
    })
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: "design-iconfont"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#FFF",
    transform: "rotate(-180 12.25 12.25)",
    d: "M12.5 10.8035221L17.6191093 16 19 14.5982389 12.5 8 6 14.5982389 7.3808907 16z",
    fillRule: "evenodd"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    ref: li_a,
    style: {
      height: '0',
      overflow: 'hidden',
      transition: ' all 0.3s ease-in-out'
    },
    className: (0, _classnames["default"])('self-navigation-container__node')
  }, configuration.map(function (item, index) {
    var _a = item || {},
        anchorId = _a.anchorId,
        label = _a.label;

    return /*#__PURE__*/_react["default"].createElement("a", {
      onClick: function onClick() {
        // @ts-ignore
        li_a.current.style.height = 0;
        setCurrentTxt(__assign(__assign({}, currentTxt || {}), {
          label: label
        }));
        setExpendNode(!expendNode);
      },
      key: index,
      className: 'self-navigation-container__nav self-navigation-container__nav--hover',
      href: anchorId
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      style: currentTxt.label === label ? {
        color: '#006eff'
      } : {},
      className: 'self-navigation-container__nav__h3 self-navigation-container__nav__h3--extend'
    }, label));
  })));
}

var _default = SelfNavigation;
exports["default"] = _default;